import { createListCollection, Flex } from '@chakra-ui/react';

import React, { useState } from 'react';
import {
  SelectContent,
  SelectItem,
  SelectLabel,
  SelectRoot,
  SelectTrigger,
  SelectValueText,
} from '@/components/ui/select';
import { Filter } from 'iconoir-react';

interface IntegrationTypeSelectorProps {
  defaultType: string; // Default selected integration type
  integrationTypes: string[]; // List of integration types
  onTypeChange: (type: string) => void; // Callback triggered when type changes
}

const IntegrationTypeSelector: React.FC<IntegrationTypeSelectorProps> = ({
  defaultType,
  integrationTypes,
  onTypeChange,
}) => {
  const [selectedType, setSelectedType] = useState<string>(defaultType);

  const types = createListCollection({
    items: integrationTypes.map((type, key) => ({
      key,
      value: type,
    })),
  });

  const handleChange = (type: string) => {
    setSelectedType(type);
    onTypeChange(type);
  };

  return (
    <SelectRoot
      variant="outline"
      collection={types}
      defaultValue={[selectedType]}
      onValueChange={(newValue) => handleChange(newValue.value[0] as string)}
      width="160px"
      size="sm"
    >
      <SelectLabel />
      <SelectTrigger>
        <Flex alignItems="center">
          <Filter width={16} height={16} />
          <SelectValueText ml={2} />
        </Flex>
      </SelectTrigger>
      <SelectContent>
        {types.items.map((type) => (
          <SelectItem item={type} key={type.key}>
            {type.value}
          </SelectItem>
        ))}
      </SelectContent>
    </SelectRoot>
  );
};

export default IntegrationTypeSelector;
